<template>
  <div class="aside-inner-component" v-if="tabHasFilters && isVisible">
    <div class="-title">
      Filter
      <div @click="reset" class="-reset -active">Reset</div>
      <div class="-right-side">
        <i @click="close" class="-close wticon wticon-close_x" title="Hide"></i>
      </div>
    </div>
    <div class="-content" ref="content">
      <wt-collapse
        v-model="openFilterTabs"
        @itemClicked="handleTabsCollapseExpand"
      >
        <template v-if="!isCreative">
          <wt-collapse-item
            v-if="isFilterAvailable('format')"
            title="Type"
            name="type"
            :key="collapseItemKey('type')"
          >
            <filter-formats
              @search="searchAssets"
              :customFormats="customFiltersOptions('format')"
            >
            </filter-formats>
          </wt-collapse-item>
          <wt-collapse-item
            v-if="isFilterAvailable('providers')"
            title="Sources"
            name="sources"
            class="-provider-list"
            :key="collapseItemKey('source')"
          >
            <filter-providers @search="searchAssets"></filter-providers>
          </wt-collapse-item>
          <wt-collapse-item
            v-if="isFilterAvailable('dateRange')"
            title="Date"
            name="date"
            :key="collapseItemKey('date')"
          >
            <filter-dates @search="searchAssets"></filter-dates>
          </wt-collapse-item>
          <wt-collapse-item
            v-if="isFilterAvailable('restrictions')"
            title="Restrictions"
            name="restriction"
            :key="collapseItemKey('restriction')"
          >
            <filter-restrictions @search="searchAssets"></filter-restrictions>
          </wt-collapse-item>
          <wt-collapse-item
            v-if="isFilterAvailable('orientation')"
            title="Orientation"
            name="orientation"
            :key="collapseItemKey('orientation')"
          >
            <filter-orientations
              @search="searchAssets"
              filter-key="orientation"
            ></filter-orientations>
          </wt-collapse-item>
          <wt-collapse-item
            v-if="isFilterAvailable('videoQuality')"
            title="Resolution"
            name="videoQuality"
            :key="collapseItemKey('videoQuality')"
          >
            <filter-quality @search="searchAssets"></filter-quality>
          </wt-collapse-item>
        </template>
        <template v-else>
          <wt-collapse-item
            v-for="filterId in filterIds"
            :title="contextFilters[filterId].caption"
            :name="filterId"
            :key="collapseItemKey(filterId)"
            :images-only-notice="subtitleText(contextFilters[filterId])"
          >
            <component
              :is="contextFilters[filterId].component"
              @search="searchAssets"
              :filter-key="filterId"
            >
            </component>
          </wt-collapse-item>
        </template>
      </wt-collapse>
    </div>
  </div>
</template>

<script>
import app from 'app';
import FilterProviders from './components/FilterProviders.vue';
import FilterRestrictions from './components/FilterRestrictions.vue';
import FilterIconList from './components/FilterIconList.vue';
import FilterSimpleList from './components/FilterSimpleList.vue';
import FilterOrientations from './components/FilterOrientations.vue';
import FilterDates from './components/FilterDates.vue';
import FilterFormats from './components/FilterFormats.vue';
import FilterQuality from './components/FilterQuality.vue';

export default app.Vue.extend({
  name: 'wt-filter-assets-bar',

  components: {
    'filter-providers': FilterProviders,
    'filter-restrictions': FilterRestrictions,
    'filter-orientations': FilterOrientations,
    'filter-orientations-creative': FilterIconList,
    'filter-number-of-people': FilterIconList,
    'filter-age-of-people': FilterSimpleList,
    'filter-ethnicity': FilterSimpleList,
    'filter-composition': FilterSimpleList,
    'filter-dates': FilterDates,
    'filter-formats': FilterFormats,
    'filter-quality': FilterQuality,
  },

  analytics: {
    hideFilterBar: 'Hide Filter Bar',
  },

  props: {},

  data() {
    return {};
  },

  computed: Object.assign(
    {
      isVisible() {
        return this.sidebarState === 'filter';
      },
      isCreative() {
        return this.searchContextId === app.PROVIDERS.WOCHIT_CREATIVE.id;
      },
      filterIds() {
        const keys = Object.keys(this.contextFilters).filter((filterId) =>
          this.isFilterAvailable(filterId)
        );
        keys.sort((a, b) => {
          return this.contextFilters[a].order > this.contextFilters[b].order
            ? 1
            : -1;
        });
        return keys;
      },
      openFilterTabs: {
        get() {
          return this.tabHasFilters && this.contextObject.openFilterTabs;
        },
        set(openedTabs) {
          this.SET_TABS_FILTER_SELECTION(openedTabs);
        },
      },
      tabHasFilters() {
        return _.isDefined(this.contextFilters);
      },
    },
    app.Vuex.mapState({
      sidebarState: (state) => state.assetGallery.sidebarState,
      searchContextId: (state) => state.assetGallery.searchContextId,
      assetsSource: (state) => state.story._assetsSource,
    }),
    app.Vuex.mapGetters(['contextObject', 'contextFilters', 'assetsSource'])
  ),

  methods: Object.assign(
    {
      collapseItemKey(name) {
        return `${name}_${this.searchContextId}_${this.assetsSource}`;
      },
      isFilterAvailable(filterId) {
        if (
          this.isVisible &&
          this.contextFilters &&
          Object.getOwnPropertyDescriptor(this.contextFilters, filterId)
        ) {
          if (this.isCreative) {
            if (
              !this.contextFilters[filterId].format ||
              !this.contextObject.props.format
            ) {
              return true;
            }
            return (
              this.contextObject.props.format ===
              this.contextFilters[filterId].format
            );
          }
          return true;
        }
        return false;
      },
      subtitleText(filter) {
        if (
          this.contextObject.props.format === null &&
          filter.format === 'IMAGE'
        )
          return 'Applies to images only';
      },
      customFiltersOptions(filterId) {
        return Object.assign(
          {},
          this.contextObject.customFiltersOptions &&
            this.contextObject.customFiltersOptions[filterId]
        );
      },

      handleTabsCollapseExpand(collapseE) {
        if (collapseE.isActive) {
          const expandedEl = collapseE.item.$el.getElementsByClassName(
            'wt2-collapse-item-content'
          )[0];

          let exapndedScroll = setInterval(() => {
            this.$refs.content.scroll({
              top: collapseE.item.$el.offsetTop - 125 /* (filters header)*/,
              behavior: 'smooth',
            });
          }, 25);

          const transitionEnded = () => {
            clearInterval(exapndedScroll);
            exapndedScroll = null;
            expandedEl.removeEventListener('transitionend', transitionEnded);
          };

          expandedEl.addEventListener('transitionend', transitionEnded);
        }
      },

      reset() {
        this.RESET_CONTEXT_FILTERS();
        this.$emit('search');
      },

      close() {
        if (this.sidebarState === 'filter') {
          this.$triggerAnalytics('hideFilterBar', { from: 'close button' });
        }
        this.SET_SIDEBAR_STATE(null);
      },
      searchAssets: _.debounce(function () {
        this.$emit('search');
      }, app.TIME.MENTAL.VISUAL),
    },
    app.Vuex.mapActions([
      'SET_TABS_FILTER_SELECTION',
      'RESET_CONTEXT_FILTERS',
      'SEARCH_ASSETS',
      'SET_SIDEBAR_STATE',
    ])
  ),
});
</script>

<style></style>
